import { render, staticRenderFns } from "./CaseNext.vue?vue&type=template&id=8ea08ae8&scoped=true"
import script from "./CaseNext.vue?vue&type=script&lang=js"
export * from "./CaseNext.vue?vue&type=script&lang=js"
import style0 from "./CaseNext.vue?vue&type=style&index=0&id=8ea08ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea08ae8",
  null
  
)

export default component.exports